import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class SeriesService {

  constructor(private firestore: AngularFirestore) { }

  public getSerie(id): Promise<any>{
    return this.firestore.collection('series').doc(id).ref.get();
  }
  public updateCounter(id, numero): any {
    return this.firestore.collection('series').doc(id).update({
      counter: numero,
    });
  }
  public updateCounterFactura(id, numero): any {
    return this.firestore.collection('series').doc(id).update({
      counterFactura: numero,
    });
  }
  public getSeriesCollection(): any {
    return this.firestore.collection('series').valueChanges({ idField: 'id' });
  }
}
